export const tableConfig = [
  {
    name: "employeeNameMechanic",
    label: " ",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "200px", minWidth: "200px", textAlign: "center" },
      }),
    },
  },
  {
    name: "y2q1",
    label: "Q1 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y2q2",
    label: "Q2 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y2q3",
    label: "Q3 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y2q4",
    label: "Q4 Y-2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y1q1",
    label: "Q1 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y1q2",
    label: "Q2 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y1q3",
    label: "Q3 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "y1q4",
    label: "Q4 Y-1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "yq1",
    label: "Q1 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "yq2",
    label: "Q2 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "yq3",
    label: "Q3 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "yq4",
    label: "Q4 Y",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export function transformChartData(input) {
  if (!input?.length) {
    return { data: [], dataKey: [] };
  }

  const quarterKeys = Object.keys(input[0]).filter(
    key => key !== "employeeNameMechanic" && key !== "no"
  );

  if (!quarterKeys.length) {
    return { data: [], dataKey: [] };
  }

  const employeeNames = input
    .map(entry => entry.employeeNameMechanic)
    .filter(name => name !== "TOTAL");


  const chartData = quarterKeys.map(quarter => {
    const row = { division: quarter };
    input.forEach(entry => {
      if (entry.employeeNameMechanic !== "TOTAL") {
        row[entry.employeeNameMechanic] = entry[quarter];
      }
    });
    return row;
  });

  // Buat dataKey dengan warna
  const colorPalette = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#a0522d"];
  const dataKey = employeeNames.map((name, index) => ({
    key: name,
    color: colorPalette[index % colorPalette.length]
  }));

  return {
    data: chartData,
    dataKey
  };
}